/* eslint-disable react/prop-types */
import { useState } from 'react';
// @mui
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableRow,
  TableBody,
  Button,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Box,
} from '@mui/material';
// components
import Scrollbar from '../../../components/scrollbar';
// sections
import ClientReqHead from '../../../components/clientHeadTable/ClientHeadTable';

// imports icon
import { ReactComponent as DeleteIcon } from '../../../theme/images/deleteTableIcon.svg';
import { ReactComponent as EditIcon } from '../../../theme/images/editTableIcon.svg';

// ----------------------------------------------------------------------

export default function ClientReqTable({
  requests,
  handleChangePage,
  page,
  onDelete,
  onEdit,
  categoryFilter,
}) {
  const [rowsPerPage] = useState(1);
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  const TABLE_HEAD = [
    { id: 'nameEn', label: t('General.nameEn'), alignRight: isRtl },
    { id: 'nameAr', label: t('General.nameAr'), alignRight: isRtl },
    { id: 'category', label: t('interface.category'), alignRight: isRtl },
    { id: 'creation_date', label: t('General.creationDate'), alignRight: isRtl },
    { id: 'action', label: t('General.Action'), alignRight: isRtl },
  ];

  const filteredContent = requests?.content?.filter((row) => {
    if (!categoryFilter || categoryFilter === 'ALL') return true;
    return row?.category === categoryFilter;
  });

  return (
    <>
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <ClientReqHead headLabel={TABLE_HEAD} />
            <TableBody>
              {filteredContent?.map((row) => {
                const { id, nameEn, nameAr, category, creationDate } = row;

                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell component="th" scope="row" align={isRtl ? 'right' : 'left'}>
                      <Typography
                        sx={{
                          color: 'text.secondary',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '20px',
                          textAlign: isRtl ? 'right' : 'left',
                        }}
                        variant="subtitle2"
                        noWrap
                      >
                        {' '}
                        {nameEn}
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row" align={isRtl ? 'right' : 'left'}>
                      <Typography
                        sx={{
                          color: 'text.secondary',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '20px',
                          textAlign: isRtl ? 'right' : 'left',
                        }}
                        variant="subtitle2"
                        noWrap
                      >
                        {' '}
                        {nameAr}
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row" align={isRtl ? 'right' : 'left'}>
                      <Typography
                        sx={{
                          color: 'text.secondary',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '20px',
                          textAlign: isRtl ? 'right' : 'left',
                        }}
                        variant="subtitle2"
                        noWrap
                      >
                        {category === 'RESIDENTIAL'
                          ? t('interface.residential')
                          : category === 'COMMERCIAL'
                          ? t('interface.commercial')
                          : category || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row" align={isRtl ? 'right' : 'left'}>
                      <Typography
                        sx={{
                          color: 'text.secondary',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '20px',
                          textAlign: isRtl ? 'right' : 'left',
                        }}
                        variant="subtitle2"
                        noWrap
                      >
                        {creationDate || ''}
                      </Typography>
                    </TableCell>
                    <TableCell align={isRtl ? 'right' : 'left'}>
                      <Box display="flex" alignItems="center" gap={2} justifyContent={'flex-start'}>
                        <Button onClick={() => onDelete(id)}>
                          <DeleteIcon />
                        </Button>
                        {onEdit && (
                          <Button onClick={() => onEdit(row)}>
                            <EditIcon />
                          </Button>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      {(!filteredContent || filteredContent.length === 0) && (
        <Box textAlign="center" sx={{ py: 3 }}>
          <h5>{t('General.noDataFound')}</h5>
        </Box>
      )}

      {requests?.totalPages > 0 && (
        <TablePagination
          rowsPerPageOptions={[9]}
          component="div"
          count={requests.totalPages}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )}
    </>
  );
}
